import { defineMessages } from '@atlassian/jira-intl';

export const searchMessage = defineMessages({
	searchRolesPlaceholder: {
		id: 'users-and-roles.text-filter.search-roles-placeholder',
		defaultMessage: 'Search roles',
		description:
			'Search placeholder in access and people page where user can search for name, email or group',
	},
	screenReaderInstruction: {
		id: 'users-and-roles.text-filter.screen-reader-instruction',
		defaultMessage: 'Results will be filtered below as you type to search or apply filters.',
		description: 'Describes what the search field and other filters do for screen reader users.',
	},
});
